import money from 'v-money'

export default function install(Vue) {
  Vue.use(money, {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: false
  })
}


// WEBPACK FOOTER //
// ./src/plugins/Money.js